import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/apiFetchShim'; // Activate fetch shim early for cookie auth
import App from './App';

// Setup window.analytics for tutorial tracking
// This is a simple console logger for now - can be replaced with real analytics later
declare global {
  interface Window {
    analytics?: {
      track: (event: string, properties?: Record<string, any>) => void;
      identify: (userId: string, traits?: Record<string, any>) => void;
      page: (name?: string, properties?: Record<string, any>) => void;
    };
  }
}

// Initialize analytics stub (logs to console for development)
if (!window.analytics) {
  window.analytics = {
    track: (event: string, properties?: Record<string, any>) => {
      console.log('[Analytics] Track:', event, properties);
      // TODO: Connect to your AnalyticsClient or external service (Mixpanel, Amplitude, etc.)
    },
    identify: (userId: string, traits?: Record<string, any>) => {
      console.log('[Analytics] Identify:', userId, traits);
    },
    page: (name?: string, properties?: Record<string, any>) => {
      console.log('[Analytics] Page:', name, properties);
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only use StrictMode in development to avoid double-mounting in production
if (process.env.NODE_ENV === 'development') {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  root.render(<App />);
}
